<label class="toggle-label">
  <div class="toggle">
    <input type="checkbox" [checked]="state" (change)="toggle()" />
    <span class="slider round" [ngClass]="{ animate: animate }"></span>
  </div>
  {{ label }}
</label>
